export default "__VITE_ASSET__W1OEr65e__"